import type { HouseholdShare } from '@/types';

export function buildHouseholdShareScopeFilter(userId: string, shareId: string | null, column = 'household_share_id') {
  if (!shareId) {
    return `user_id.eq.${userId}`;
  }

  return `${column}.eq.${shareId},and(user_id.eq.${userId},${column}.is.null)`;
}

export function mapHouseholdShareRow(row: any): HouseholdShare | null {
  if (!row) return null;

  return {
    id: row.id,
    inviteCode: row.invite_code,
    ownerUserId: row.owner_user_id,
    ownerDisplayName: row.owner_display_name || 'Household',
    memberUserId: row.member_user_id || null,
    memberDisplayName: row.member_display_name || null,
    status: row.status === 'active' ? 'active' : 'invited',
    createdAt: row.created_at,
  };
}

export function getHouseholdSharePeerName(share: HouseholdShare | null, currentUserId: string | null) {
  if (!share || !currentUserId) return null;
  if (share.ownerUserId === currentUserId) {
    return share.memberDisplayName || null;
  }
  if (share.memberUserId === currentUserId) {
    return share.ownerDisplayName || null;
  }
  return share.memberDisplayName || share.ownerDisplayName || null;
}
